import http from '../../../http-common';

export function requestLoadClasificacionMovimientos() {
    return http.get('/clasificacion-movimientos-bancarios');
}

export function requestSaveClasificacionMovimiento(clasificacion) {
    return http.post('/clasificacion-movimientos-bancarios', clasificacion);
}
